export default function removeTrailingSlash(pathname) {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/$/, "");
}
